import React from "react";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export const PageHero = ({ eyebrow, title, intro, breadcrumb }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-36 pb-20 sm:pt-40 sm:pb-24 bg-gradient-to-b from-[#F4F7F6] via-white to-white overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 -z-10 pointer-events-none">
        <div className="absolute -top-32 right-1/4 h-[360px] w-[360px] rounded-full bg-[#0284C7]/10 blur-3xl" />
        <div className="absolute top-12 -left-24 h-[300px] w-[300px] rounded-full bg-[#16A34A]/10 blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {breadcrumb && (
          <nav className="flex items-center gap-1.5 text-sm text-slate-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#0284C7]">Home</Link>
            <ChevronRight size={14} className="text-slate-400" />
            <span className="text-slate-700 font-medium">{breadcrumb}</span>
          </nav>
        )}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          {eyebrow && (
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#0284C7]">
              {eyebrow}
            </span>
          )}
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0F172A] text-balance leading-[1.05]">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 font-body text-lg text-slate-600 leading-relaxed">
              {intro}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};
